import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { ElementGroup } from 'components/Editor/EditorElements/elements.types'
import { genElementConfig } from 'components/Editor/EditorElements/genElementConfig'
import { t } from 'services/Translation'

import Demo from '../MediaDemo'
import VideoElement from '../MediaElement'
import MediaFormValue from '../MediaFormValue'
import videoIcon from '../assets/video.svg'
import VideoFormBrand from './VideoFormBrand'
import { STYLE_FORM_SCHEMA } from './VideoFormStyle'

export default genElementConfig(CONFIG_ELEMENTS.video, {
  label: t('elements.video.label'),
  icon: videoIcon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: VideoElement,
  Demo: [Demo('video')],
  FormValue: MediaFormValue,
  FormBrand: VideoFormBrand,
  EditorActions: null,
})
